import { PropertyManager } from './PropertyManager';
import { FilterProvider } from './AssetManagerContext';
import { isAdmin, isVAFull } from 'utils/util';

function authorized() {
    return isAdmin();
}

export function AssetManager() {
    return (
        <>
            {!authorized() && <>Not authorized</>}
            {authorized() && (
                <FilterProvider>
                    <PropertyManager />
                </FilterProvider>
            )}
        </>
    );
}
